import React from "react";
import NavbarTop from "../Components/NavbarTop";
import { ReactComponent as MailImg } from "../../assets/illustration/MailSent.svg";
import { Link } from "react-router-dom";
import logo from "../../assets/logo/radis.png";

const SigninConfirmationPage = () => {
  return (
    <>
      {/* <NavbarTop /> */}
      <div className="h-full flex items-center">
        <div className=" flex justify-center w-full top-[120px]">
          <div className="bg-white h-[580px] w-[960px] shadow-lg relative rounded-2xl flex justify-center">
            <div className="relative space-y-4 flex justify-center w-[400px]">
              {/* <Link to="/Home"> */}
                <MailImg className="absolute top-5 w-[350px]" />
              {/* </Link> */}
              <h1 className="relative text-3xl w-[500px] top-96 text-center font-Poppins-SemiBold h-[50px]">
                Un lien de connexion vous a été envoyé !
              </h1>
              <p className="text-[#BEC4C] absolute bottom-2 text-xs font-Poppins-Light">
                Fait pour la planète par lokalité © - 2022
              </p>
            </div>
          </div>
          <img
            src={logo}
            alt="logo"
            className="absolute h-[320px] transparent left-[965px] top-[120px] opacity-30"
          />
        </div>
      </div>
    </>
  );
};

export default SigninConfirmationPage;
